module.exports = __webpack_public_path__ + "img/dateblack.950aa195.svg";